// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import LogoPreviewController from "./logo_preview_controller"
application.register("logo-preview", LogoPreviewController)

import InviteRowsController from "./invite_rows_controller"
application.register("invite-rows", InviteRowsController)

import ModalController from "./modal_controller"
application.register("modal", ModalController)

import SubmitsOnChangeController from "./submits_on_change_controller"
application.register("submits-on-change", SubmitsOnChangeController)
